import { MbePackage, MbeSafeValue, MbeSignature } from '@/components/icons';

export const extraServicesNeeded = [
  {
    id: 'isPackagingNeeded',
    label: 'FORM.EXTRA_SERVICE_PACKAGING',
    hasInfo: false,
  },
  {
    id: 'isInsuranceRequested',
    label: 'FORM.EXTRA_SERVICE_INSURANCE',
    hasInfo: true,
  },
];

export const extraServices = [
  {
    id: 'signatureRequired',
    icon: MbeSignature,
    name: 'EXTRA_SERVICES.SIGNATURE_NAME',
    description: 'EXTRA_SERVICES.SIGNATURE_DESC',
    label: 'EXTRA_SERVICES.SIGNATURE_LABEL',
  },
  {
    id: 'packaging',
    icon: MbePackage,
    name: 'EXTRA_SERVICES.PACKAGING_NAME',
    description: 'EXTRA_SERVICES.PACKAGING_DESC',
    label: 'EXTRA_SERVICES.PACKAGING_LABEL',
  },
  {
    id: 'safeValue',
    icon: MbeSafeValue,
    name: 'EXTRA_SERVICES.SAFE_VALUE_NAME',
    description: 'EXTRA_SERVICES.SAFE_VALUE_DESC',
    label: 'EXTRA_SERVICES.SAFE_VALUE_LABEL',
  },
  {
    id: 'safeValueArt',
    icon: MbeSafeValue,
    name: 'EXTRA_SERVICES.SAFE_VALUE_ART_NAME',
    description: 'EXTRA_SERVICES.SAFE_VALUE_ART_DESC',
    label: 'EXTRA_SERVICES.SAFE_VALUE_ART_LABEL',
  },
];
